import { render, staticRenderFns } from "./FormCreateOrUpdateView.vue?vue&type=template&id=5fb59a1d&"
import script from "./FormCreateOrUpdateView.vue?vue&type=script&lang=js&"
export * from "./FormCreateOrUpdateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports